/**
 * Validate if the input is a valid routing number.
 * - Must be 9 digits.
 * - Must pass checksum validation ((n_0 * 3) + (n_1 * 7) + (n_2 * 1) + (n_3 * 3) + (n_4 * 7) + (n_5 * 1) + (n_6 * 3) + (n_7 * 7) + (n_8 * 1)) % 10 = 0
 * - First 2 digits must fall within ranges: 01-12, 21-32, 61-72
 *
 * @param {string} routingNumber
 * @returns {boolean}
 */
export function validateRoutingNumber (routingNumber: string): boolean {
  if (routingNumber.length !== 9) {
    return false
  }

  if (!/^\d+$/.test(routingNumber)) {
    return false
  }

  const firstTwoNumeric = parseInt(routingNumber.substring(0, 2), 10)

  if (
    !(firstTwoNumeric >= 1 && firstTwoNumeric <= 12) &&
      !(firstTwoNumeric >= 21 && firstTwoNumeric <= 32) &&
      !(firstTwoNumeric >= 61 && firstTwoNumeric <= 72)
  ) {
    return false
  }

  const checksum = routingNumber.split('').reduce((a, c, ind) => {
    if (ind % 3 === 0) {
      return parseInt(c, 10) * 3 + a
    }

    if (ind % 3 === 1) {
      return parseInt(c, 10) * 7 + a
    }

    return parseInt(c, 10) * 1 + a
  }, 0)

  if (checksum % 10 !== 0) {
    return false
  }
  return true
}
